var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
var SlideHome = /** @class */ (function (_super) {
    __extends(SlideHome, _super);
    function SlideHome() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SlideHome.prototype.beforeMount = function () {
        var _this = this;
        var timeInterval = setInterval(function () {
            if (window.youtubeLoaded) {
                clearInterval(timeInterval);
                _this.playVideo();
            }
        }, 300);
        console.log(console.log('muteYouTubeVideoPlayer' + this.index));
    };
    SlideHome.prototype.playVideo = function () {
        var _this = this;
        var videoStartedInId = 0;
        console.log('muteYouTubeVideoPlayer' + this.index);
        this.player = new YT.Player('muteYouTubeVideoPlayer' + this.index, {
            videoId: this.video,
            width: '100%',
            height: '100%',
            playerVars: {
                autoplay: 1,
                controls: 0,
                showinfo: 0,
                modestbranding: 1,
                loop: 0,
                fs: 0,
                cc_load_policy: 0,
                iv_load_policy: 0,
                autohide: 0,
                start: videoStartedInId,
                end: 440,
                disablekb: 1,
                onReady: 1,
                playlist: this.video
            },
            events: {
                onReady: function (e) {
                    console.log('sdsd');
                    e.target.mute();
                    e.target.setVolume(0);
                    e.target.setPlaybackQuality('highres');
                    _this.setAspectRatio();
                    window.addEventListener('resize', function () {
                        _this.setAspectRatio();
                    });
                },
                onStateChange: function (e) {
                    // Hack para funcionar tempo
                    if (videoStartedInId > _this.player.getCurrentTime() && videoStartedInId != 0) {
                        document.getElementById('background-cover-video').style.display = "none";
                        document.getElementById('background-cover-video-mobile').style.display = "none";
                        _this.player.seekTo(videoStartedInId);
                    }
                    if (e.data === YT.PlayerState.PLAYING) {
                        document.getElementById('background-cover-video').style.display = "none";
                        document.getElementById('background-cover-video-mobile').style.display = "none";
                        document.getElementsByClassName('video')[0].classList.add('started');
                    }
                    if (e.data === YT.PlayerState.ENDED) {
                        e.target.playVideo();
                        _this.player.seekTo(videoStartedInId);
                        e.target.mute();
                        e.target.setVolume(0);
                        e.target.setPlaybackQuality('highres');
                    }
                }
            }
        });
    };
    SlideHome.prototype.setAspectRatio = function () {
        var outer = document.getElementById("video");
        var videoCover = document.getElementById("video-cover");
        var box = document.getElementById('muteYouTubeVideoPlayer' + this.index);
        if (videoCover.clientHeight > window.innerWidth) {
            box.style.width = (outer.clientWidth * ((videoCover.clientHeight * 1.3) / outer.clientHeight)) + 'px';
            box.style.height = (videoCover.clientHeight * 1.3) + 'px';
        }
        else {
            box.style.height = (outer.clientHeight * ((window.innerWidth * 1.2) / outer.clientWidth)) + 'px';
            box.style.width = (window.innerWidth * 1.2) + 'px';
        }
    };
    __decorate([
        Prop()
    ], SlideHome.prototype, "video", void 0);
    __decorate([
        Prop()
    ], SlideHome.prototype, "index", void 0);
    SlideHome = __decorate([
        Component({
            components: {},
        })
    ], SlideHome);
    return SlideHome;
}(Vue));
export default SlideHome;
